<template>
  <v-card tile elevation="1" class="z-index-2">
    <v-toolbar flat dense color="white">
      <v-toolbar-title class="font-weight-bold grey--text text--darken-2">
        Gestión de Activos
      </v-toolbar-title>

      <v-spacer />

      <v-btn-toggle
        :value="listaModo"
        mandatory
        rounded
        class="custom-toggle"
        color="primary"
        @change="onToggleChange"
      >
        <v-btn value="armarios" small>
          <v-icon left small>mdi-dresser</v-icon>
          Armarios
        </v-btn>

        <v-btn v-if="verPlanos"value="planos" small>
          <v-icon left small>mdi-map-marker-path</v-icon>
          Planos
        </v-btn>

        <v-btn icon value="armarios" color="primary" small @click="$emit('open-scanner')">
          <v-icon small>mdi-qrcode-scan</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-spacer />

      <v-btn icon v-if="isMobile" @click="$emit('toggle-drawer')">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>
  </v-card>
</template>

<script>
export default {
  name: "ArmariosToolbar",
  props: {
    listaModo: { type: String, required: true },
    isMobile: { type: Boolean, default: false },
    verPlanos: {type: Boolean, default: true},
  },
  methods: {
    onToggleChange(val) {
      // val será 'armarios' o 'planos'
      this.$emit("change-modo", val);
    },
  },
};
</script>

<style scoped>
.custom-toggle {
  background-color: #f0f0f0 !important;
  border: 1px solid #e0e0e0;
}
.custom-toggle .v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
}
</style>